import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'styled-components';
import ControlledCollaborationSidebarProvider from './ControlledCollaborationSidebarProvider';
import useCollaborationSidebarProps from '../hooks/useCollaborationSidebarProps';
import AsyncExpandableCollaborationSidebar from '../features/floatingSidebar/components/ExpandableCollaborationSidebar/AsyncExpandableCollaborationSidebar';
import AsyncCollaborationSidebarDropArea from '../features/floatingSidebar/components/CollaborationSidebarDropArea/AsyncCollaborationSidebarDropArea';
import { Flex } from 'foundations-components/components/Flex';

/**
 * This component assumes collaborationSidebarState and
 * onUpdateCollaborationSidebarState are passed in. See
 * LayoutWithCollaborationSidebar for example
 * implementation
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PageContents = styled.div.withConfig({
  displayName: "ControlledLayoutWithCollaborationSidebar__PageContents",
  componentId: "xj95qw-0"
})(["min-width:0;flex:1 1 auto;"]);
function PageLayout({
  children
}) {
  const {
    pageContentRef,
    setIsPageContentRefSet,
    withoutSidebar
  } = useCollaborationSidebarProps(); // TODO can we remove need for these?

  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "stretch",
    blockSize: "100%",
    flexGrow: 1,
    children: [/*#__PURE__*/_jsx(PageContents, {
      ref: ref => {
        pageContentRef.current = ref;
        setIsPageContentRefSet(true);
      },
      children: children
    }), /*#__PURE__*/_jsx(AsyncExpandableCollaborationSidebar, {}), withoutSidebar ? null : /*#__PURE__*/_jsx(AsyncCollaborationSidebarDropArea, {})]
  });
}
export default function ControlledLayoutWithCollaborationSidebar(_ref) {
  let {
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(ControlledCollaborationSidebarProvider, Object.assign({}, props, {
    children: /*#__PURE__*/_jsx(PageLayout, {
      children: children
    })
  }));
}